import { FC } from 'react'
import {
    reactAppBranchColour,
    reactAppStageColour,
    reactBranch,
} from '../utils'
import { Box } from '@mui/material'
import { reactAppStage } from '../utils/reactAppStage'

export const DevOverlay: FC = () => {
    return (
        <Box
            position={'absolute'}
            top={0}
            left={0}
            width={0}
            height={0}
            zIndex={9999999}
        >
            <Box
                width={16}
                height={16}
                sx={{
                    backgroundImage: `linear-gradient(${reactAppStageColour()} 0,${reactAppStageColour()} 50%,${reactAppBranchColour()} 50%)`,
                }}
            >
                <Box display={'grid'} gridTemplateColumns={'16px'} gap={0}>
                    <span
                        style={{
                            fontSize: '8px',
                            lineHeight: '8px',
                            textShadow:
                                '-0.5px 0px 1px white, 0.5px 0px 1px white',
                        }}
                    >
                        {reactAppStage()}
                    </span>
                    <span
                        style={{
                            fontSize: '8px',
                            lineHeight: '8px',
                            textShadow:
                                '-0.5px 0px 1px white, 0.5px 0px 1px white',
                        }}
                    >
                        {reactBranch()}
                    </span>
                </Box>
            </Box>
        </Box>
    )
}
